export class SigninRequestVO {
    private username: string;
    private password: string;

    public setUsername(username: string): void{
        this.username = username;
    }

    public getUsername(): string{
        return this.username;
    }

    public setPassword(password: string): void{
        this.password = password;
    }

    public getPassword(): string{
        return this.password;
    }
}

export class SigninResponseVO {
    private accessToken: string;
    private refreshToken: string;
    private id: number;
    private emailId: string;
    private firstName: string;
    private lastName: string;

    public getId():number{
        return this.id;
    }

    public getEmailId():string{
        return this.emailId;
    }

    public getFirstName():string{
        return this.firstName;
    }

    public getLastname():string{
        return this.lastName;
    }

    public setId(id: number): void{
        this.id = id;
    }

    public setEmailId(emailId: string): void{
        this.emailId = emailId;
    }

    public setFirstName(firstName: string): void{
        this.firstName = firstName;
    }

    public setLastName(lastName: string): void{
        this.lastName = lastName;
    }    

    constructor(signResponseJson: any) {
        this.accessToken = signResponseJson.accessToken;
        this.refreshToken = signResponseJson.refreshToken;
        this.id = signResponseJson.id;
        this.emailId = signResponseJson.emailId;
        this.firstName = signResponseJson.firstName;
        this.lastName = signResponseJson.lastName;
    }


    public getAccessToken(): string {
        return this.accessToken;
    }

    public getRefreshToken(): string {
        return this.refreshToken;
    }

    public setAccessToken(accessToken: string): void {
        this.accessToken = accessToken;
    }

    public setRefreshToken(refreshToken: string): void {
        this.refreshToken = refreshToken;
    }
}


// WEBPACK FOOTER //
// ./src/app/signin/signin.models.ts